import styled from "styled-components";
import { MainWrapper, MainHeader } from "../../../components/01_config/MainStyles";

const Wrapper = styled(MainWrapper)`
`

const Header = styled(MainHeader)`

`

export { Wrapper, Header  }